<!-- <app-top-bar-announcement></app-top-bar-announcement> -->
<app-home-header></app-home-header>
<router-outlet></router-outlet>
<!-- <app-home-footer></app-home-footer> -->
